import { AuthService } from 'src/app/services/auth.service';
import { Observable, Subscription } from 'rxjs';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Admin, AdminAction, AdminStatus } from 'sharedTypes/admin';
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OptionsdialogComponent } from '../../optionsdialog/optionsdialog.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-admin-name-action-indicator',
    templateUrl: './admin-name-action-indicator.component.html',
    styleUrls: ['./admin-name-action-indicator.component.scss'],
    standalone: false,
})
export class AdminNameActionIndicatorComponent implements OnInit, OnDestroy {
    statusColor = 'grey';
    @Input() user: { name: string; shortName: string; sipgateUserId: string; uid: string } = {
        name: 'Unbekannt',
        shortName: '?',
        sipgateUserId: '',
        uid: '',
    };
    statusInfo = '';
    lastAction: AdminAction = new AdminAction();
    lastStatus: AdminStatus = new AdminStatus();
    actionSub: Subscription = new Subscription();
    statusSub: Subscription = new Subscription();

    constructor(
        private firebaseService: FirebaseService,
        public authService: AuthService,
        private cdr: ChangeDetectorRef,
        public dialog: MatDialog,
        private datePipe: DatePipe,
    ) {}

    ngOnInit(): void {
        // getLastAdminAction

        this.actionSub = this.firebaseService.getLastAdminAction(this.user.uid).subscribe((lastAction) => {
            let statusColor = 'grey';
            if (lastAction && lastAction[0]) {
                this.lastAction = lastAction[0];
                const jetzt = new Date().getTime();
                const minSeitLetzerAction = (jetzt - this.lastAction.atUnix) / 1000 / 60;
                if (minSeitLetzerAction < 60) {
                    statusColor = 'red';
                }
                if (minSeitLetzerAction < 30) {
                    statusColor = 'orange';
                }
                if (minSeitLetzerAction < 15) {
                    statusColor = 'green';
                }
                this.statusColor = statusColor;
                this.cdr.detectChanges();
            }
        });
        this.statusSub = this.firebaseService.getLastAdminStatus(this.user.uid).subscribe((lastStatus) => {
            this.statusInfo = '';
            if (lastStatus && lastStatus[0]) {
                this.lastStatus = lastStatus[0];
                this.statusInfo =
                    'Seit: ' + this.datePipe.transform(this.lastStatus.atUnix, 'dd.MM.yyyy - HH:mm') + ' Uhr';
            }
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy(): void {
        if (this.actionSub) {
            this.actionSub.unsubscribe();
        }
    }

    async setStatus() {
        if (this.user.uid !== this.authService.getUid()) {
            return;
        }
        const cfg = new MatDialogConfig();

        cfg.width = '300px';

        const optionen = ['Anwesend', 'Pause', 'Feierabend', 'Unterwegs', 'Beschäftigt'];
        const res = ['home_work', 'coffee', 'bedtime', 'emoji_transportation', 'do_not_disturb_on'];
        cfg.data = {
            titel: 'Bitte Status wählen',
            frage: '',
            optionen: optionen,
        };

        const dialogRef = this.dialog.open(OptionsdialogComponent, cfg);
        dialogRef.afterClosed().subscribe((result) => {
            if (result !== null && result !== undefined) {
                this.firebaseService.saveAdminStatus(res[result]);
            }
        });
    }
}
